module.exports = __webpack_public_path__ + "img/logo-menu.9e504b62.png";